'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import MilestonesController from "./controller/milestones";
import MilestoneModalCreateController from "./controller/milestoneModalCreate";
import MilestoneModalSelectController from "./controller/milestoneModalSelect";
import MilestoneTableDirective from "./directive/milestoneTable";
import MilestoneService from "./service/milestone";
import MilestoneSelectController from "./controller/milestoneSelect";

export default angular.module('investmentProject.milestone', [])
    .controller('MilestonesController', MilestonesController)
    .controller('MilestoneModalCreateController', MilestoneModalCreateController)
    .controller('MilestoneModalSelectController', MilestoneModalSelectController)
    .controller('MilestoneSelectController', MilestoneSelectController)
    .directive('milestoneTable', MilestoneTableDirective)
    .factory('MilestoneService', MilestoneService)
    .name;
